import { render } from "./search-index.vue?vue&type=template&id=3c794dc5&scoped=true"
import script from "./search-index.vue?vue&type=script&lang=js"
export * from "./search-index.vue?vue&type=script&lang=js"

import "./search-index.vue?vue&type=style&index=0&id=3c794dc5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c794dc5"]])

export default __exports__